import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import {
  getCartProducts,
  deleteCartProduct,
  deleteCart,
  getTotal,
  importCart,
  setNote,
  setNoteToDB,
  temporalImportedData
} from "../../store/cart";
import {
  isCartOpened,
  getCurrencySign,
  toggleModal,
  toggleCart
} from "../../store/common";
import CartItemContainer from "./CartItemContainer";
import ImportCSVModal from "../../containers/ImportCSVModal";
import { RingLoader } from "react-spinners";
import { Input } from "reactstrap";
import * as Papa from "papaparse";

const CartContainer = ({
  deleteCart,
  cartProducts,
  deleteCartProduct,
  getTotal,
  isCartOpened,
  currencySign,
  availableCart,
  importCartProduct,
  customerDiscount,
  customerPriceLevel,
  setNote,
  note,
  isImporting,
  actionType,
  isLoading,
  toggleCart,
  translate,
  setNoteToDB,
  getFile,
  isImportModalOpened,
  userCredit
}) => {
  return (
    <div className={"cartBar__inner" + (isCartOpened ? " enabled" : "")}>
      <div className={"cartBar__floating"}>
        <div className="cartBar__header">
          <div>{translate("containers.cart.cartContainer.cart_item")}</div>

          {customerPriceLevel && (
            <div>
              {customerPriceLevel}{" "}
              {translate("containers.cart.cartContainer.level")}
            </div>
          )}
        </div>
        <div className="cartBar__actions">
          {/* <button
            type="button"
            className="cartBar__actions__buy"
            onClick={() => {
              toggleCart();
              browserHistory.push("/summary");
              browserHistory.go();
            }}
          >
            {translate("containers.cart.cartContainer.buy_now")}
          </button> */}
          <button
            type="button"
            className="cartBar__actions__delete"
            onClick={() => deleteCart()}
          >
            {translate("containers.cart.cartContainer.delete_all")}
          </button>
        </div>
        <RingLoader color={"#fff"} loading={isLoading} size={120} margin={20} />
        <div className={"cartBar__items"}>
          {!isLoading && cartProducts && cartProducts.length > 0
            ? cartProducts.map(cartProduct => (
              <CartItemContainer
                key={cartProduct.id}
                cartProduct={cartProduct}
                deleteCartProduct={() => deleteCartProduct(cartProduct.id)}
              />
            ))
            : "still loading"}
        </div>
        <div className="cartBar__sum">
          <span>
            {getTotal} {currencySign}
          </span>
        </div>
        {availableCart && (
          <div className="cartBar__actions">
            <button
              type="button"
              className={
                "cartBar__actions__import " + (isImporting && "importing")
              }
              onClick={importCartProduct}
            >
              {isImporting
                ? translate("containers.cart.cartContainer.btn_is_importing")
                : translate("containers.cart.cartContainer.btn_to_import")}
            </button>
          </div>
        )}
        <div className="cartBar__credit__info">{translate('availableCredit')}:<strong>{userCredit}</strong></div>
        <div className="cartBar__note">
          <div>{translate("containers.cart.cartContainer.note")}</div>
          <Input
            type="textarea"
            name="text"
            onBlur={e => {
              setNoteToDB(e.target.value);
            }}
            onChange={e => setNote(e.target.value)}
            placeholder={note || "Note is automatically saved"}
            value={note}
          />
        </div>
        {(actionType === "commision" || actionType === "basic" || actionType === "special") && (
          <div className="cartBar__actions">
            <input
              id="file"
              type="file"
              onChange={getFile}
              className={"cartBar__actions__import fileBtn"}
            />
            <label htmlFor="file">
              {isImportModalOpened ? "Uploading..." : "Import CSV"}
            </label>
          </div>
        )}
        <ImportCSVModal />
      </div>
    </div>
  );
};

CartContainer.propTypes = {
  cartProducts: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
    ean: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired
  }).isRequired,
  deleteCart: PropTypes.func.isRequired,
  deleteCartProduct: PropTypes.func.isRequired,
  getTotal: PropTypes.number,
  isCartOpened: PropTypes.bool,
  currencySign: PropTypes.string,
  availableCart: PropTypes.bool,
  importCartProduct: PropTypes.func,
  customerDiscount: PropTypes.number,
  customerPriceLevel: PropTypes.string,
  setNote: PropTypes.func,
  note: PropTypes.string,
  isImporting: PropTypes.bool,
  handleData: PropTypes.func,
  handleError: PropTypes.func,
  actionType: PropTypes.number,
  isLoading: PropTypes.bool,
  toggleCart: PropTypes.func,
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getTranslate(state.locale),
  cartProducts: getCartProducts(state.cart.list),
  getTotal: getTotal(state.cart.list, null),
  isCartOpened: isCartOpened(state.common.cartOpen),
  currencySign: getCurrencySign(state.common.user.currency.sign),
  availableCart: state.cart.availableToImport,
  customerDiscount: state.common.user.personal.discount
    ? state.common.user.personal.discount
    : null,
  customerPriceLevel:
    state.common.user.personal.price_level &&
      state.common.user.personal.price_level !== "A"
      ? state.common.user.personal.price_level
      : null,
  note: state.cart.note,
  isImporting: state.cart.isImporting,
  actionType: state.customer.actionOnCustomer,
  isLoading: state.cart.loadingItems,
  isImportModalOpened: state.common.modals.import_csv_modal,
  userCredit: state.common.user.credit,
});

const mapDispatchToProps = dispatch => ({
  deleteCart: () => dispatch(deleteCart()),
  deleteCartProduct: id => dispatch(deleteCartProduct(id)),
  importCartProduct: () => dispatch(importCart()),
  // setNote: debounce(val => {
  //   dispatch(setNote(val));
  // }, 500),
  setNote: val => dispatch(setNote(val)),
  setNoteToDB: val => dispatch(setNoteToDB(val)),
  getFile: e => {
    Papa.parse(e.target.files[0], {
      delimiter: ";",
      header: false,
      complete(results) {
        const rows = results.data
          .filter(d => d.length > 1)
          .map(d => {
            return { code: d[0], quantity: Number(d[1]) };
          });
        var data = Object.values(
          rows.reduce((c, { code, quantity }) => {
            c[code] = c[code] || { code, quantity: 0 };
            c[code].quantity += quantity;
            c[code].approved = true;
            return c;
          }, {})
        );
        dispatch(temporalImportedData(data));
        dispatch(toggleModal("import_csv_modal", true));
      }
    });
  },
  toggleCart: () => dispatch(toggleCart())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CartContainer);



// WEBPACK FOOTER //
// ./src/containers/Cart/CartContainer.js